interface Props {
  categories: string[];
  selectedCategory: string | null;
  setSelectedCategory: (v: string | null) => void;
  priceRange: string;
  setPriceRange: (v: string) => void;
  sortBy: string;
  setSortBy: (v: string) => void;
  total: number;
}

const SORTS = [
  { label: '評分最高', value: 'rating' },
  { label: '諮詢次數', value: 'sessions' },
  { label: '價格從低', value: 'price-asc' },
  { label: '價格從高', value: 'price-desc' },
];
const PRICE_RANGES = [
  { label: '全部價格', value: 'all' },
  { label: '≤$200', value: '0-200' },
  { label: '$201–$250', value: '200-250' },
  { label: '$251–$300', value: '250-300' },
  { label: '$300+', value: '300+' },
];

const MentorFilters = ({
  categories,
  selectedCategory, setSelectedCategory,
  priceRange, setPriceRange,
  sortBy, setSortBy,
  total,
}: Props) => (
  <div className="bg-white border border-slate-100 rounded-2xl p-5 sticky top-24">
    <div className="mb-6">
      <div className="text-xs font-semibold text-slate-400 uppercase tracking-widest mb-3">
        排序方式
      </div>
      <div className="flex flex-col gap-1.5">
        {SORTS.map((s) => (
          <button
            key={s.value}
            onClick={() => setSortBy(s.value)}
            className={`text-left text-sm px-3 py-2 rounded-lg font-medium cursor-pointer transition-colors whitespace-nowrap ${
              sortBy === s.value
                ? 'bg-violet-50 text-violet-700'
                : 'text-slate-600 hover:bg-slate-50'
            }`}
          >
            {sortBy === s.value && <i className="ri-check-line mr-1.5 text-violet-500" />}
            {s.label}
          </button>
        ))}
      </div>
    </div>

    <div className="border-t border-slate-100 pt-5 mb-6">
      <div className="text-xs font-semibold text-slate-400 uppercase tracking-widest mb-3">
        諮詢價格
      </div>
      <div className="flex flex-col gap-1.5">
        {PRICE_RANGES.map((p) => (
          <button
            key={p.value}
            onClick={() => setPriceRange(p.value)}
            className={`text-left text-sm px-3 py-2 rounded-lg font-medium cursor-pointer transition-colors whitespace-nowrap ${
              priceRange === p.value
                ? 'bg-amber-50 text-amber-700'
                : 'text-slate-600 hover:bg-slate-50'
            }`}
          >
            {priceRange === p.value && <i className="ri-check-line mr-1.5 text-amber-500" />}
            {p.label}
          </button>
        ))}
      </div>
    </div>

    <div className="border-t border-slate-100 pt-5">
      <div className="text-xs font-semibold text-slate-400 uppercase tracking-widest mb-3">
        專業方向
      </div>
      <div className="flex flex-col gap-1.5">
        {categories.map((cat) => (
          <button
            key={cat}
            onClick={() => setSelectedCategory(selectedCategory === cat ? null : cat)}
            className={`text-left text-sm px-3 py-2 rounded-lg font-medium cursor-pointer transition-colors whitespace-nowrap ${
              selectedCategory === cat
                ? 'bg-violet-50 text-violet-700'
                : 'text-slate-600 hover:bg-slate-50'
            }`}
          >
            {selectedCategory === cat && <i className="ri-check-line mr-1.5 text-violet-500" />}
            {cat}
          </button>
        ))}
      </div>
    </div>

    <div className="mt-5 pt-4 border-t border-slate-100 text-center text-xs text-slate-400">
      共 <span className="font-bold text-violet-600">{total}</span> 位導師符合條件
    </div>
  </div>
);

export default MentorFilters;
